﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { StorageService } from "@app/services/storage.service";
import { UploadService } from "@app/services/upload.service";
import { IDialogService } from "@models";
import { Utils } from "@tools";

interface IUploadEventArgs {
    file: File;
}
interface IUploadScope extends IInputScope {
    /** the button text */
    label: string;
    /** to bind to this include the file parameter:  <kb-upload upload="myhandler(file)"> */
    upload: (args: IUploadEventArgs) => ng.IPromise<any>;
    cleared: () => void;
    accept: string;


    _fileName: () => string;
    _btnClick: () => void;
    _clear: () => void;
    _thumbnailDataUrl: any;
}

@NgComponent({
    token: Token.KbUpload,
    dependencies: [
        Token.$Timeout,
        Token.UploadService,
        Token.DialogService,
        Token.StorageService
    ]
})
export class KbUpload extends KbInput {
    constructor(
        $timeout: ng.ITimeoutService,
        uploadService: UploadService,
        dialogService: IDialogService,
        storageService: StorageService
    ) {
        super($timeout);

        this.restrict = "EA";
        this.scope = Utils.extend(this.scope, {
            upload: "&",
            cleared: "&",
            accept: "@"
        });
        this.template = Dirs.component("kb-upload");

        this.link = (scope: IUploadScope, element: ng.IAugmentedJQuery, atts: ng.IAttributes) => {

            scope._fileName = () => {
                if (atts.guid && scope.ngModel && scope.ngModel.path) {
                    return scope.ngModel.path.substr(scope.ngModel.path.indexOf("_") + 1);
                } else {
                    return scope.ngModel.path;
                }
            };
            scope._clear = () => {
                dialogService.confirm("Are you sure you want to remove this upload?", () => {
                    scope.ngModel.path = null;
                    scope.ngModel.assetId = null;
                    scope._thumbnailDataUrl = "";
                    scope.ngChange();
                    scope.cleared();
                });
            };
            scope._btnClick = () => {
                uploadService.promptUserToChooseFile(scope.accept).then((file: File) => {
                    if (!scope.ngModel) scope.ngModel = {path: null, assetId: null};
                    scope.ngModel.path = file.name;
                    let uploadPromise = scope.upload({ file }).then(() => {
                        // only trigger valuechange when upload is done so the rules have
                        // the file(especially important for images being uploaded to the scene)
                        scope.ngChange();
                    });
                        
                    // show a thumbnail of the image
                    if (file.type.match("image.*")) {
                        scope._thumbnailDataUrl = storageService.getAssetUrl("images/spinning_circle.gif");
                        let reader = new FileReader();
                        reader.onloadend = () => {
                            scope._thumbnailDataUrl = reader.result;
                            reader.onloadend = null;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        scope._thumbnailDataUrl = null;
                    }
                });
            };
        };
    }
}
